import Button from "components/shared/button";
import Input, { InputType } from "components/shared/inputs/input";
import { useEffect, useState } from "react";
import { useDatasourceOptions } from "./";

type Props = {
  onBack: () => void;
  onSubmit: (data: Record<string, any>) => Promise<void>;
  initialData?: Record<string, any> | null;
};

const COLOR_OPTIONS = [
  { value: "primary", text: "blue" },
  { value: "secondary", text: "grey" },
  { value: "success", text: "green" },
  { value: "danger", text: "red" },
  { value: "warning", text: "yellow" },
  { value: "info", text: "light_blue" },
  { value: "light", text: "white" },
  { value: "dark", text: "dark" },
];

const ColorCardWidgetForm: React.FC<Props> = ({ onBack, onSubmit: onSubmitProp, initialData }) => {
  const [title, setTitle] = useState("");
  const [color, setColor] = useState("primary");
  const [datasource, setDatasource] = useState("");
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { datasourceOptions } = useDatasourceOptions();

  useEffect(() => {
    setTitle(String(initialData?.title ?? ""));
    setColor(String(initialData?.color ?? "primary") || "primary");
    setDatasource(String(initialData?.datasource ?? ""));
    setContent(String(initialData?.content ?? ""));
  }, [initialData]);

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      await onSubmitProp({
        type: "ColorCard",
        title,
        color,
        datasource,
        content,
        nocard: true,
      });
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <group data-gap="20" data-max-length="500">
        <group data-length="autofit">
          <Input
            dataLength="autofit"
            size="large"
            type="text"
            label="title"
            name="color_card_widget_title"
            value={title}
            onChange={(e: any) => setTitle(String(e.target?.value ?? ""))}
          />
        </group>
      </group>

      <group data-gap="20" data-max-length="500">
        <group data-length="autofit">
          <Input
            dataLength="autofit"
            size="large"
            type={InputType.Select}
            label="color_type"
            name="color_card_widget_color"
            value={color}
            options={COLOR_OPTIONS}
            onChange={(v: any) => setColor(String(v ?? ""))}
          />
        </group>
      </group>

      <group data-gap="20" data-max-length="500">
        <group data-length="autofit">
          <Input
            dataLength="autofit"
            size="large"
            type={InputType.Select}
            label="Source"
            name="color_card_widget_datasource"
            value={datasource}
            options={datasourceOptions}
            onChange={(v: any) => setDatasource(String(v ?? ""))}
          />
        </group>
      </group>

      <group data-gap="20" data-max-length="500">
        <group data-length="autofit">
          <Input
            dataLength="autofit"
            size="large"
            type="text"
            label="text_content"
            name="color_card_widget_content"
            value={content}
            onChange={(e: any) => setContent(String(e.target?.value ?? ""))}
          />
        </group>
      </group>

      <group data-wrap="no" data-gap="10">
        <Button type="button" primary text="submit" onClick={handleSubmit} disabled={isLoading} />
        <Button type="button" text="back" onClick={onBack} disabled={isLoading} />
      </group>
    </>
  );
};

export default ColorCardWidgetForm;
